import React, {Fragment} from 'react';

import {Divider, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';

import {SelfNetworkProps} from './types';
import {useUnitList} from '../../hooks/useUnitList';
import {UnitGrid} from '../UnitGrid';
import {NetworkHeader} from '../NetworkHeader';
import {StyledButton} from '../../styles';
import {EmptySelfNetworAlert} from '../EmptySelfNetworkAlert';
import {EmptyAppointmentsCard} from '../EmptyAppointmentsCard';
import {SpecialtyNotAvailableOnlineCard} from 'presentation/modules/booking/shared/ui/components/SpecialtyNotAvailableOnlineCard';

const {selfNetwork} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow;

export function SelfNetwork({
	list,
	flowType,
	handleNextStep,
	networkType,
	shouldShowEmptyAppointmentsCard,
	showSpecialtyNotAvailableCard,
}: SelfNetworkProps) {
	const {
		listByLocality,
		listByDistance,
		listByDistanceIsEmpty,
		listByLocalityIsEmpty,
		unitsByDistanceTitle,
		selfNetworkButtonLabel,
		selfNetworkButtonAction,
		selfNetworkButtonDataTagId,
		showEmptySelftNetworkAlert,
		showUnitsByDistanceTitle,
		getNetworkHeaderDescription,
		shouldHideDivider,
		shouldHideNetworkHeaderInSelfByLocality,
		shouldHideNetworkHeaderInSelfByDistance,
		shouldHideSelfNetworkComponent,
		shouldHideSelfNetworkButton,
		showDistanceReferenceInSelfNetworkLocalityList,
	} = useUnitList({list, flowType, networkType, showSpecialtyNotAvailableCard});

	if (shouldHideSelfNetworkComponent()) return null;

	return (
		<Stack gap={2}>
			{showEmptySelftNetworkAlert ? (
				<EmptySelfNetworAlert list={list} flowType={flowType} />
			) : (
				<Fragment>
					{listByLocalityIsEmpty ? null : (
						<UnitGrid
							list={listByLocality}
							handleNext={handleNextStep}
							showDistanceReference={showDistanceReferenceInSelfNetworkLocalityList}
							flowType={flowType}>
							{shouldHideNetworkHeaderInSelfByLocality ||
							shouldShowEmptyAppointmentsCard ? null : (
								<NetworkHeader
									title={selfNetwork.title}
									description={getNetworkHeaderDescription()}
								/>
							)}
							{shouldShowEmptyAppointmentsCard ? <EmptyAppointmentsCard /> : null}

							{showSpecialtyNotAvailableCard ? (
								<SpecialtyNotAvailableOnlineCard selfNetworkVariant />
							) : null}
						</UnitGrid>
					)}

					{listByDistanceIsEmpty ? null : (
						<UnitGrid
							list={listByDistance}
							handleNext={handleNextStep}
							flowType={flowType}
							showDistanceReference
							hideFilterResultTitle={!listByLocalityIsEmpty}>
							{shouldHideNetworkHeaderInSelfByDistance ? null : (
								<NetworkHeader
									title={selfNetwork.title}
									description={getNetworkHeaderDescription()}
								/>
							)}
							{showUnitsByDistanceTitle ? (
								<Typography
									variant="subtitle2"
									color="text.secondary"
									lineHeight={1.75}>
									{unitsByDistanceTitle}
								</Typography>
							) : null}
						</UnitGrid>
					)}
				</Fragment>
			)}

			{shouldShowEmptyAppointmentsCard || showSpecialtyNotAvailableCard ? null : (
				<Stack gap={2}>
					{shouldHideSelfNetworkButton ? null : (
						<StyledButton
							data-tag-id={selfNetworkButtonDataTagId()}
							variant="outlined"
							size="large"
							onClick={selfNetworkButtonAction}>
							{selfNetworkButtonLabel()}
						</StyledButton>
					)}

					{shouldHideDivider() ? null : <Divider />}
				</Stack>
			)}
		</Stack>
	);
}
